import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Divider, LinearProgress } from '@mui/material';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import * as monitoringSlice from '../../../data/monitoring.slice';
import * as lookupSlice from '../../../data/lookup.slice';
import { useParams } from 'react-router-dom';
import { WorkQueue as WorkQueueModel } from '../../../data/models/work-queue.model';
import WorkQueueHeader from './WorkQueueHeader';
import WorkQueueTable from './WorkQueueTable';

const PREFIX = 'WorkQueue';

const classes = {
  container: `${PREFIX}-container`,
  content: `${PREFIX}-content`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  [`& .${classes.content}`]: {
    padding: theme.spacing(2),
  },
}));

export default function WorkQueue() {
  const dispatch = useAppDispatch();
  const params = useParams<{ id: string }>();
  const workQueues = useAppSelector(monitoringSlice.selectWorkQueues);
  const loadingWorkQueues = useAppSelector(
    monitoringSlice.selectLoadingWorkQueues,
  );
  const loadedWorkQueues = useAppSelector(
    monitoringSlice.selectLoadedWorkQueues,
  );
  const tasks = useAppSelector(monitoringSlice.selectCurrentWorkQueueList);
  const loadingTasks = useAppSelector(
    monitoringSlice.selectLoadingWorkQueueList,
  );

  const [workQueue, setWorkQueue] = React.useState<WorkQueueModel>();

  React.useEffect(() => {
    dispatch(lookupSlice.fetchLookupItemsAsync('taskResolveReason'));
    dispatch(lookupSlice.fetchLookupItemsAsync('taskEscalateReason'));
  }, []);

  React.useEffect(() => {
    if (!loadedWorkQueues) {
      dispatch(monitoringSlice.fetchWorkQueuesAsync());
    }
  }, [loadedWorkQueues]);

  React.useEffect(() => {
    if (params.id && workQueues) {
      const queue = workQueues.find((tq) => tq.workQueueUUID === params.id);
      setWorkQueue(queue);
      dispatch(monitoringSlice.fetchWorkQueueListAsync(params.id));
    }
  }, [params.id, workQueues]);

  return (
    <StyledBox className={classes.container}>
      {loadingWorkQueues && <LinearProgress color="primary" />}
      {!loadingWorkQueues && <WorkQueueHeader name={workQueue?.name || ''} />}
      <Box className={classes.content}>
        <WorkQueueTable tasks={tasks} loading={loadingTasks} />
      </Box>
    </StyledBox>
  );
}
